module.exports = __webpack_public_path__ + "img/tutorial_books_02.b349f63f.gif";